import React from "react";
import {
  MagnifyingGlassIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from "@heroicons/react/24/outline";

function DexKorOverview({ setView, setupDetails }) {
  return (
    <div
      className="-m-2.5 overflow-auto"
      style={{
        msOverflowStyle: "none",
        scrollbarWidth: "none",
        // maxHeight: "359px",
      }}
    >
      <div
        style={{
          background: `linear-gradient(90deg, ${
            setupDetails?.widgetCustomizations?.primaryColor || "#4c73de"
          } 0%,  ${
            setupDetails?.widgetCustomizations?.secondaryColor || "#2a4dad"
          } 100%)`,
        }}
        className="bg-blue-800 p-4 "
      >
        <div className="flex items-center">
          <ChevronLeftIcon
            onClick={() => {
              setView("Help");
            }}
            className="w-5 h-5 text-white cursor-pointer"
          />
          <div className="flex-grow text-center text-white text-xl font-semibold">
            Help
          </div>
        </div>

        <div className="relative mt-4">
          <input
            type="text"
            placeholder="Search for help"
            className="text-sm rounded-lg px-4 py-3.5 w-full"
          />
          <div className="absolute inset-y-0 right-4 flex items-center">
            <MagnifyingGlassIcon
              style={{
                color:
                  setupDetails?.widgetCustomizations?.primaryColor || "#4c73de",
              }}
              className="w-5 h-5 cursor-pointer"
              strokeWidth={2}
            />
          </div>
        </div>
      </div>
      <div className="p-5 text-start border-b">
        <div className="font-bold">DexKor Overview</div>
        <p className="text-sm pt-1">
          See how your AI-first customer service solution works.
        </p>
        <div className="flex items-center justify-between pt-2">
          <div className="flex flex-col">
            <span className="text-sm text-gray-600">20 articles</span>
            <span className="text-sm text-gray-600">By Anish and 2 others</span>
          </div>
          <div className="flex -space-x-4 rtl:space-x-reverse">
            <img
              className="w-10 h-10 border-2 border-white rounded-full dark:border-gray-800"
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/49/Elon_Musk_2015.jpg/408px-Elon_Musk_2015.jpg"
              alt=""
            />
            <img
              className="w-10 h-10 border-2 border-white rounded-full dark:border-gray-800"
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/49/Elon_Musk_2015.jpg/408px-Elon_Musk_2015.jpg"
              alt=""
            />
            <img
              className="w-10 h-10 border-2 border-white rounded-full dark:border-gray-800"
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/49/Elon_Musk_2015.jpg/408px-Elon_Musk_2015.jpg"
              alt=""
            />
          </div>
        </div>
      </div>

      <div
        className="flex items-center py-3 px-5 hover:bg-gray-200 cursor-pointer"
        onClick={() => {
          setView("DexKor");
        }}
      >
        <div className="text-start flex-1">
          <p className="text-sm pt-1 pb-1 break-words">What is DexKor?</p>
        </div>
        <ChevronRightIcon className="h-3 w-3 ml-2" strokeWidth={4} />
      </div>
      <div className="flex items-center py-3 px-5 hover:bg-gray-200 cursor-pointer">
        <div className="text-start flex-1">
          <p className="text-sm pt-1 pb-1 break-words">
            DexKor features explained
          </p>
        </div>
        <ChevronRightIcon className="h-3 w-3 ml-2" strokeWidth={4} />
      </div>
      <div className="px-5 hover:bg-gray-200 cursor-pointer">
        <div className="flex items-center py-3 border-b">
          <div className="text-start flex-1">
            <p className="text-sm pt-1 pb-1 break-words">The DexKor Glossary</p>
          </div>
          <ChevronRightIcon className="h-3 w-3 ml-2" strokeWidth={4} />
        </div>
      </div>

      <div className="px-5 cursor-pointer hover:bg-gray-200 mb-4">
        <div className="flex items-center py-3 border-b">
          <div className="text-start flex-1">
            <h5 className="font-bold">Plans & pricing</h5>
            <p className="text-sm pt-1 pb-1 break-words">
              DexKor's new plans launched November 15, 2024
            </p>
            <span className="text-sm text-gray-600">17 articles</span>
          </div>
          <ChevronRightIcon className="h-3 w-3 ml-2" strokeWidth={4} />
        </div>
      </div>
    </div>
  );
}

export default DexKorOverview;
